import {
    Button,
    type ButtonProps
} from 'tradera/components/atoms/button/button';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import { useTranslator } from 'tradera/lang/translate';
import styles from './chip.module.scss';

type ChipProps = Pick<ButtonProps, 'onClick' | 'href'> & {
    title: string;
    onRemove?: (
        e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
    ) => void;
};

export const Chip = ({
    title,
    href,
    onClick,
    onRemove,
    ...buttonProps
}: ChipProps) => {
    const { t } = useTranslator();
    return (
        <Button
            theme="search"
            size="xs"
            className="text-nowrap text-capitalize focus-visible-inner d-flex align-items-center"
            onClick={(e) => {
                onClick?.(e);
            }}
            href={href}
            {...buttonProps}>
            <span className={onRemove ? 'mr-3' : ''}>{title}</span>
            {onRemove && (
                <div
                    role="button"
                    className={styles.removeButton}
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onRemove?.(e);
                    }}
                    tabIndex={0}
                    aria-label={t('chip_remove')}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.code === 'Space') {
                            e.preventDefault();
                            onRemove?.(e);
                        }
                    }}>
                    <CloseIcon />
                </div>
            )}
        </Button>
    );
};
